/**
 * Material category lookup (migration 0019). Thin wrapper over the shared
 * lookup so call sites read in domain terms rather than generic ones.
 */

import { indexByName, toOptions, type Lookup } from '@/lib/lookup';
import type { MaterialCategoryRow } from '@/types/database';

export type MaterialCategoryIndex = Lookup<MaterialCategoryRow>;

export function indexMaterialCategories(rows: MaterialCategoryRow[]): MaterialCategoryIndex {
  return indexByName(rows);
}

export function materialCategoryOptions(
  rows: MaterialCategoryRow[],
): { value: string; label: string }[] {
  return toOptions(rows);
}
